var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutMLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 48,
    viewBox: "0 0 98 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.8795C12.0706 37.4462 20.8614 39.1058 32.7353 36.4478C41.0616 34.5838 49.2685 31.8797 57.2177 28.7705C66.4724 25.1507 75.7125 21.0273 83.9969 15.4472C92.2814 9.8671 97 1 97 1",
    stroke: "#C9C1AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47C17.5117 33.1934 41.6313 15.7615 61.9618 6.5689C67.1241 4.23471 73.2308 1.72978 79 1",
    stroke: "#650D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMLine1);
export default __webpack_public_path__ + "static/media/aboutMLine1.52c030a567ffafd38dccce9ba2d97869.svg";
export { ForwardRef as ReactComponent };